module.exports = __webpack_public_path__ + "static/media/parejas2.4455f670.jpg";